import { render, staticRenderFns } from "./AppPackageDetailsModal.vue?vue&type=template&id=2992c948"
import script from "./AppPackageDetailsModal.vue?vue&type=script&lang=js"
export * from "./AppPackageDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./AppPackageDetailsModal.vue?vue&type=style&index=0&id=2992c948&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports